import * as React from 'react';
import { FIELD_TYPE, withSimpleForm, requiredValidation } from 'app/infrastructure/simple-form';
import { endpoint, importTranslations, form } from 'app/area/import/constants';
import { SerializeType, SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { STATE } from 'app/constants';
import { simpleFieldForPath } from 'app/infrastructure/simple-form/';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { ImportFormData, ImportFileStatus } from 'app/area/import/types';
import { ImportCase } from 'app/area/import/types-store';
import { SimpleFormValidationConfig } from 'app/infrastructure/simple-form/validation/types';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

export interface ImportEditCaseComponentProps {
  importCase?: ImportCase;
  onClose: (importCaseId: number) => void;
  onDone: (importFormData: ImportFormData) => void;
}

const SimpleForm = simpleFieldForPath(STATE.import);

export type ImportEditCaseContainerProps = ImportEditCaseComponentProps & DefaultContainerProps & SimpleFormProps;
export class ImportEditCaseComponent extends React.Component<ImportEditCaseContainerProps> {

  public static statePath: string = STATE.import;

  private validationConfig: SimpleFormValidationConfig = [
    requiredValidation(form.importset)
  ];

  private onSubmit = () => {
    const { validate, serialize, onDone, translation } = this.props;
    validate(this.validationConfig,
      () => onDone(serialize(defaultSerializeMappings) as any), translation.validation_error);
  };

  private onClose = () => {
    this.props.onClose(this.props.importCase.id);
  };

  public render() {
    const { importCase, translation } = this.props;

    return (
      <ModalWrapper
        headerTitle={translation.import_file_to_synergi_life}
        btnTitle={translation.import_submit}
        btnCancelTitle={translation.import_cancel}
        onClose={this.onClose}
        onDone={this.onSubmit}
        largeSize={false}
        closeOnDone={false}>
        <SimpleForm
          name={form.importset}
          type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
          optionsEndpoint={endpoint.loadImportSetOptions}
          label={{ text: translation.import_set, required: true }}
          initialValue={importCase.importSet && { value: importCase.importSet.v, description: importCase.importSet.d }}
          translation={translation}
          placeholder={translation.import_search_placeholder}
          serialize={{ type: SerializeType.V_VALUE }}
          readOnly={importCase.importStatus && importCase.importStatus.v === ImportFileStatus.completed ? true : false} />
        <SimpleForm
          name={form.comments}
          type={FIELD_TYPE.TEXTAREA}
          label={{ text: translation.import_file_description }}
          initialValue={importCase.comments}
          translation={translation}
          maxLength={254}
          serialize={{ type: SerializeType.PRIMITIVE_VALUE }} />
      </ModalWrapper>
    );
  }
}

const container = containerFactory<ImportEditCaseComponentProps>(withSimpleForm(ImportEditCaseComponent), {},
  undefined, importTranslations);
export { container as ImportEditCase };
